import {view, Icon} from '@sail/ui';
import type {IconAsset} from '@sail/icons/types';
import {Text} from 'src/v2/components/common/Text';
import {COLORS} from 'src/v2/util/color';

interface SelectionCardProps {
  icon: IconAsset;
  iconBorderRadius?: string;
  label: string;
  sublabel?: string;
  detail: string;
  selected: boolean;
  onSelect: () => void;
}

export const SelectionCard = ({
  icon,
  iconBorderRadius = 'xsmall',
  label,
  sublabel,
  detail,
  selected,
  onSelect,
}: SelectionCardProps) => {
  return (
    <view.button
      role="option"
      aria-selected={selected}
      onClick={onSelect}
      css={{
        stack: 'x',
        alignItems: 'center',
        gap: 'small',
        paddingX: 'space.150',
        paddingY: 'medium',
        borderRadius: 'small',
        borderWidth: 'small',
        borderStyle: 'solid',
        borderColor: selected ? COLORS.borderSelected : COLORS.borderOnLight,
        backgroundColor: 'transparent',
        cursor: 'pointer',
        width: 'fill',
      }}
    >
      <Icon
        icon={icon}
        css={{
          width: 'space.250',
          height: 'space.250',
          borderRadius: iconBorderRadius,
          flexShrink: 0,
        }}
      />
      <view.div
        css={{
          stack: 'x',
          alignItems: 'center',
          distribute: 'space-between',
          gap: 'small',
          flex: 1,
          minWidth: 'space.0',
        }}
      >
        <Text type="bodyEmphasized" css={{flex: 1, minWidth: '0px'}}>
          {label}
          {sublabel ? (
            <>
              {' '}
              <Text
                type="bodyEmphasized"
                css={{color: COLORS.textDisabledOnLight}}
              >
                {sublabel}
              </Text>
            </>
          ) : null}
        </Text>
        <Text
          type="caption"
          css={{color: COLORS.textSubduedOnLight, flexShrink: 0}}
        >
          {detail}
        </Text>
      </view.div>
    </view.button>
  );
};
